<div class="content-box">
  <div class="title-cancel">
    <h3>
      {{ selectedPaths.size == 1 ? currentPath.name : 'Trajetos Selecionados' }}
    </h3>
    <i class="button-icon fas fa-xmark fa-lg cursor-pointer" (click)="closeSideBar()"></i>
  </div>
  <div class="form-infos">
    <div>
      {{ sidebarIdSelected != '-' ? 'Atualizado: ' + (currentPath?.updatedAt | date: 'dd/MM/yyyy - HH:mm') : '' }}
    </div>

    <!-- Select Múltiplo de Trajeto -->
    <div class="d-flex flex-column">
      <h4 class="mb-2">Trajetos</h4>
      <div class="input-button d-flex justify-content-between" style="border-radius: 8px; width: 95%" [id]="'path'">
        <div class="d-flex align-items-center" style="max-width: 85%; overflow: hidden; height: 25px">
          <div class="d-flex tags-selected" [id]="'tags-selected'">
            <div *ngFor="let path of selectedPaths | keyvalue: originalOrder" class="item-selected">
              <h4 class="mr-2 item-text">{{ isValueKeyId(path.key, pathsList) }}</h4>
              <i (click)="removeOptionFilter(path.key)" class="fas fa-xmark cursor-pointer"></i>
            </div>
          </div>
        </div>
        <div class="count-plus">
          <span *ngIf="overflowCounter > 0" style="color: var(--gray-base)">{{ '+ ' + overflowCounter }}</span>
        </div>
        <select
          class="form-control input-search ml-0"
          (change)="addOptionFilter($event.target.value)"
          [(ngModel)]="lastSelected"
          [value]="lastSelected"
        >
          <option value="" hidden>Selecione</option>
          <option *ngFor="let path of pathsList" [hidden]="selectedPaths.has(path?.id)" [value]="path.id">
            {{ selectedPaths.has(path?.id) ? '' : path.name }}
          </option>
        </select>
      </div>
    </div>
    <!-- Select Múltiplo de Trajeto -->

    <!-- Select KM Inicial e Final -->
    <div class="d-flex mt-4">
      <div class="col pl-0">
        <label for="startsAt" [ngClass]="{ 'text-muted': selectedPaths.size > 1 || sidebarIdSelected == '-' }"
          >KM Inicial</label
        >
        <select
          name="startsAt"
          (change)="startEndChange(currentPath?.id)"
          id="startsAt"
          [(ngModel)]="startsAt"
          class="form-control"
          [disabled]="selectedPaths.size > 1 || sidebarIdSelected == '-'"
        >
          <option [value]="undefined" hidden>0</option>
          <option [value]="start" *ngFor="let start of startEndList">{{ start }}</option>
        </select>
      </div>

      <div class="col pr-0">
        <label for="endsAt" [ngClass]="{ 'text-muted': selectedPaths.size > 1 || sidebarIdSelected == '-' }"
          >KM Final</label
        >
        <select
          name="endsAt"
          (change)="startEndChange(currentPath?.id)"
          id="endsAt"
          [(ngModel)]="endsAt"
          class="form-control"
          [disabled]="selectedPaths.size > 1 || sidebarIdSelected == '-'"
        >
          <option [value]="undefined" hidden>0</option>
          <option [value]="end" *ngFor="let end of startEndList">{{ end }}</option>
        </select>
      </div>
    </div>
    <!-- Select KM Inicial e Final -->

    <h3 class="info-title">Informações Gerais</h3>

    <div class="white-box">
      <span
        >Valor Total dos Trajetos Selecionados:
        <span class="text-success">{{ totalCost | currency: 'BRL' }}</span>
      </span>

      <ng-container *ngIf="selectedPaths.size == 1; else listPaths">
        <span
          >{{ 'Valor Total do Trecho KM ' + startsAt + ' - KM ' + endsAt + ': ' }}
          <span class="text-success">{{ pathCost | currency: 'BRL' }}</span>
        </span>
      </ng-container>

      <ng-template #listPaths>
        <ng-container *ngFor="let path of selectedPaths | keyvalue">
          <span
            >{{ 'Valor Total do Trajeto ' + getPathName(path.key) + ': ' }}
            <span class="text-success">{{ selectedPaths[path.key] | currency: 'BRL' }}</span>
          </span>
        </ng-container>
      </ng-template>
    </div>

    <h3 class="info-title">Sinalizações nesse trecho</h3>

    <!-- Sinalizações e Garantia -->
    <div class="d-flex">
      <div class="col pl-0">
        <select name="signType" id="signType" [(ngModel)]="signType" class="form-control">
          <option value="">Todas as sinalizações</option>
          <option [value]="type.value" *ngFor="let type of signTypeEnum | keyvalue: originalOrder">
            {{ textSelect('sign', type.value) }}
          </option>
        </select>
      </div>

      <div class="col pr-0">
        <select name="warrantyType" id="warrantyType" [(ngModel)]="warrantyType" class="form-control">
          <option value="">Todas as garantias</option>
          <option [value]="type.value" *ngFor="let type of warrantyTypeEnum | keyvalue: originalOrder">
            {{ textSelect('warranty', type.value) }}
          </option>
          <option value="retro">{{ 'Alerta de Retrorrefletorização' }}</option>
        </select>
      </div>
    </div>
    <!-- Sinalizações e Garantia -->

    <span class="my-3"
      >{{ signsListSize.size }}
      <span class="text-muted">{{ ' Sinalizações no trajeto' }}</span>
    </span>

    <ng-container *ngFor="let sign of verticalSigns">
      <div class="white-box cursor-pointer" (click)="signDetailRouting(sign)" *ngIf="showSign(sign)">
        <div class="sign-line">
          <div class="sign-flex">
            <div
              class="center-row"
              [ngStyle]="{
                color: retroAlertExist(sign.id, sign.type)
                  ? 'var(--orange-base)'
                  : sign.active == 1
                  ? 'var(--green-base)'
                  : 'var(--red-base)'
              }"
            >
              <i class="p-icon fas fa-circle"></i>
            </div>
            <div class="d-flex position-relative" *ngIf="sign?.combined >= 1">
              <i class="icon-sign-link fa-solid fa-link" placement="right"></i>
            </div>

            <div class="row m-0 align-items-center position-relative">
              <!-- SVG Sem Complemento -->
              <div
                *ngIf="!sign.complementInformationType"
                [ngClass]="sign.signCode | enumCaption: 'Caption':40"
                class="position-relative internal-caption"
              >
                <span>{{ sign?.verticalType != verticalSignalizationType?.Indication ? sign?.internalCaption : '' }}</span>
                <img [src]="sign.signCode | enumSvg: 'Signaling'" style="width: 40px; object-fit: contain; height: 40px" />
              </div>
              <!-- SVG Sem Complemento -->

              <!-- SVG Com Complemento -->
              <div
                *ngIf="sign.type == signTypeEnum.Vertical && sign.complementInformationType"
                class="d-flex justify-content-center"
                style="height: 60px; width: 40px"
              >
                <img
                  *ngIf="sign.complementInformationType == complementInformationTypeEnum.Additional"
                  [src]="complementType(sign) | enumSvg: 'ComplementInformation'"
                  style="width: 40px; height: 20px; object-fit: contain; position: absolute; bottom: 4px"
                />
                <img
                  *ngIf="sign.complementInformationType == complementInformationTypeEnum.Incorporated"
                  [src]="complementType(sign) | enumSvg: 'ComplementInformation'"
                  style="width: 40px; height: 60px; object-fit: contain; position: absolute"
                />
                <div
                  [ngClass]="sign.signCode | enumCaption: 'Caption':32"
                  class="position-relative internal-caption"
                  style="height: 32px; width: 32px; top: 4px"
                >
                  <span class="position-absolute" style="z-index: 1">{{ sign?.verticalType != verticalSignalizationType?.Indication ? sign?.internalCaption : '' }}</span>
                  <img
                    [src]="sign.signCode | enumSvg: 'Signaling':signType"
                    style="width: 32px; height: 32px; object-fit: contain; position: absolute"
                  />
                </div>
              </div>
              <!-- SVG Com Complemento -->
            </div>

            {{ sign.signCode | enumText: 'Signaling' }}
          </div>
          <span class="text-success">{{ sign.cost | currency: 'BRL' }}</span>
        </div>
      </div>
    </ng-container>

    <ng-container *ngFor="let sign of horizontalSigns">
      <div class="white-box cursor-pointer" (click)="signDetailRouting(sign)" *ngIf="showSign(sign)">
        <div class="sign-line">
          <div class="sign-flex">
            <div
              class="center-row"
              [ngStyle]="{
                color: retroAlertExist(sign.id, sign.type)
                  ? 'var(--orange-base)'
                  : sign.active == 1
                  ? 'var(--green-base)'
                  : 'var(--red-base)'
              }"
            >
              <i class="p-icon fas fa-circle"></i>
            </div>

            <div>
              <img [src]="sign.signCode | enumSvg: 'Signaling'" style="width: 40px; object-fit: contain; height: 40px" />
            </div>

            {{ sign.signCode | enumText: 'Signaling' }}
          </div>
          <span class="text-success">{{ sign.cost | currency: 'BRL' }}</span>
        </div>
      </div>
    </ng-container>

    <ng-container *ngFor="let sign of deviceSigns">
      <div class="white-box cursor-pointer" (click)="signDetailRouting(sign)" *ngIf="showSign(sign)">
        <div class="sign-line">
          <div class="sign-flex">
            <div class="center-row" [ngStyle]="{ color: sign.active == 1 ? 'var(--green-base)' : 'var(--red-base)' }">
              <i class="p-icon fas fa-circle"></i>
            </div>

            <div>
              <img [src]="sign.signCode | enumSvg: 'Signaling'" style="width: 40px; object-fit: contain; height: 40px" />
            </div>

            {{ sign.signCode | enumText: 'Signaling' }}
          </div>
          <span class="text-success">{{ sign.cost | currency: 'BRL' }}</span>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- Template Popover Tipo de Tarefa  -->
<ng-template #popoverType>
  <span class="text-white popover-info">{{
    'Tarefa de ' + (popoverCurrentTask?.taskType | enumText: 'TaskType')
  }}</span>
</ng-template>
<!-- Template Popover Tipo de Tarefa  -->

<!-- Template Popover Prioridade da Tarefa  -->
<ng-template #popoverPriority>
  <span class="text-white popover-info">{{
    'Prioridade ' + popoverCurrentTask?.priority
      ? (popoverCurrentTask?.priority | enumText: 'OrderPriority')
      : 'Não informado'
  }}</span>
</ng-template>
<!-- Template Popover Prioridade da Tarefa  -->

<!-- Template Popover Status da Tarefa  -->
<ng-template #popoverStatus>
  <span class="text-white popover-info">{{ popoverCurrentTask?.status | enumText: 'TaskStatus' }}</span>
</ng-template>
<!-- Template Popover Status da Tarefa  -->

<!-- Template Popover Data Execução  -->
<ng-template #popoverExecution>
  <span class="text-white popover-info">Data de Execução</span>
</ng-template>
<!-- Template Popover Data Execução  -->

<!-- Template Popover Data de Conclusão  -->
<ng-template #popoverEnd>
  <span class="text-white popover-info">Data de Conclusão</span>
</ng-template>
<!-- Template Popover Data de Conclusão  -->

<!-- Template Popover Tempo de Resolução  -->
<ng-template #popoverTime>
  <span class="text-white popover-info">Tempo de Resolução</span>
</ng-template>
<!-- Template Popover Tempo de Resolução  -->

<!-- Template Popover Atrasada para concluir  -->
<ng-template #popoverLate>
  <span class="text-white popover-info">Atrasada para Concluir</span>
</ng-template>
<!-- Template Popover Atrasada para concluir  -->
